export default __webpack_public_path__ + "static/media/DSC_7770.8e5c0a24.jpg";